import { useAct } from 'DashboardUser/store'
import AsyncSelect from 'Shared/components/AsyncSelect'

export default function OrganisationFilter({filterKey, closeConfiguration}) {
    const act = useAct();

    const dashboardField = useSel(s => s.dashboard.dashboardFields.find(f => 'field_' + f.id === filterKey) ?? null);
    const filter = useSel(s => s.local.filters ? s.local.filters[filterKey] : null);

    const setFilter = (val) => {
        act.local.setFilter(filterKey, val);
        closeConfiguration();
    }

    const clearFilter = () => {
        act.local.setFilter(filterKey, null);
        closeConfiguration();
    }

    const selectedValue = filter && filter !== '[present]' && filter !== '[blank]' ? filter : null;

    return <div className="organisation-filter">
        <div className="filter-configuration-input-container">
            <AsyncSelect
                entity="organisation"
                value={selectedValue}
                queryParameters={{ externalType: dashboardField?.organisationKind }}
                onChange={(v) => v && setFilter(String(v))}
            />
        </div>
        <a href="#" className={`filter-configuration-option ${filter === '[present]' ? 'active' : ''}`} onClick={() => setFilter('[present]')}>Has organisation</a>
        <a href="#" className={`filter-configuration-option ${filter === '[blank]' ? 'active' : ''}`} onClick={() => setFilter('[blank]')}>Missing organisation</a>
        {filter && <>
            <div className="filter-configuration-option-divider"></div>
            <a href="#" className="filter-configuration-option configuration-option-clear" onClick={clearFilter}>Clear</a>
        </>}
    </div>
}
